/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bonhomme': {
    width: 13.387,
    height: 14.162,
    viewBox: '0 0 13.387 14.162',
    data: '<g _fill="#766e6a"><path pid="0" data-name="Tracé 151" d="M12.927 14.163a.493.493 0 0 1-.5-.5 5.717 5.717 0 0 0-11.433 0 .5.5 0 0 1-1 0 6.693 6.693 0 0 1 13.385 0 .472.472 0 0 1-.458.5"/><path pid="1" data-name="Tracé 152" d="M6.713 7.769a3.884 3.884 0 1 1 3.884-3.884 3.876 3.876 0 0 1-3.884 3.884m0-6.792a2.908 2.908 0 1 0 2.888 2.908A2.882 2.882 0 0 0 6.713.977"/></g>'
  }
})
